module.exports = __webpack_public_path__ + "static/media/cat-lg-1.8287f1d4.jpg";